import { useMutation } from "react-query";
import { MedicalExaminationService } from "@services/medical-examination.service";

export const useDownloadMedicalExamApplicantsMutation = () => {
  return useMutation(MedicalExaminationService.downloadApplicantsList);
};
